import React from 'react';
import PropTypes from 'prop-types';

function ShareWidget({ shareWidgetKeys, text, url }) {
  return (
    <div className="c-social-share" style={{ right: [-60, -108, -157, -205][Math.max(0, Math.min(shareWidgetKeys.length - 1, 3))] }}>
      <h2>Share</h2>

      <div className="c-social-share__wrapper">
        {shareWidgetKeys.includes('facebook') && (
        <a
          className="c-social-icons__icon"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
          rel="noreferrer"
          target="_blank"
        >
          <span className="u-visually-hidden">Facebook</span>

          <svg>
            <use xlinkHref="#facebook" />
          </svg>
        </a>
        )}

        {shareWidgetKeys.includes('twitter') && (
        <a
          className="c-social-icons__icon"
          href={`https://twitter.com/intent/tweet/?text=${text}&url=${encodeURIComponent(url)}`}
          rel="noreferrer"
          target="_blank"
        >
          <span className="u-visually-hidden">Twitter</span>

          <svg>
            <use xlinkHref="#twitter" />
          </svg>
        </a>
        )}

        {shareWidgetKeys.includes('reddit') && (
        <a
          href={`https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${text}`}
          className="c-social-icons__icon"
          rel="noreferrer"
          target="_blank"
        >
          <span className="u-visually-hidden">Reddit</span>

          <svg>
            <use xlinkHref="#reddit" />
          </svg>
        </a>
        )}

        {shareWidgetKeys.includes('email') && (
        <a
          href={`mailto:?subject=${text}&body=${encodeURIComponent(url)}`}
          className="c-social-icons__icon"
          rel="noreferrer"
          target="_blank"
        >
          <span className="u-visually-hidden">Email</span>

          <svg>
            <use xlinkHref="#envelope" />
          </svg>
        </a>
        )}
      </div>
    </div>
  );
}

ShareWidget.propTypes = {
  shareWidgetKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default ShareWidget;
